<template>
  <SnackbarNotification
    v-model:show="notification.show.value"
    :type="notification.type.value"
    :title="notification.title.value"
    :text="notification.text.value"
    :timeout="notification.timeout.value"
  />
</template>

<script setup>
import { inject } from "vue";
import SnackbarNotification from "@/components/common/SnackbarNotification.vue";

const notification = inject("notify");
</script>
